module.exports = __webpack_public_path__ + "img/no_image.2207faa8.png";